module.exports = __webpack_public_path__ + "static/media/close-menu.2c73d4cc.svg";